import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import CountryForm from '../components/CountryForm';
import { useCountryDetails } from '../hooks/useCountryDetails';
import { useUpdateCountry } from '../hooks/useCountryMutations';
import type { CountryFormData } from '@/shared/types';

export default function CountryEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading: loadingDetails } = useCountryDetails(id);
  const mutation = useUpdateCountry();

  const handleSubmit = (formData: CountryFormData) => {
    mutation.mutate({ id: id!, data: formData }, { onSuccess: () => navigate('/countries') });
  };

  if (loadingDetails) return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', padding: 48 }} />;

  return (
    <div>
      <PageHeader back title={t('countries.edit')} subtitle={data?.nameEn} />
      <Card style={{ marginTop: 16 }}>
        <CountryForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
